module.exports = __webpack_public_path__ + "static/media/frame2.4a3dfa32.svg";